import styled from 'styled-components'

interface MenuChevronStylesInterface {
  opened: boolean
  color: string | undefined
}

export const MenuChevronUi = styled.i<MenuChevronStylesInterface>`
  ${p => (p.opened ? `transform: rotate(180deg);` : ``)}
  transition: transform 0.3s ease-in-out;
  ${p => (p.color ? `color: ${p.color};` : '')};
`
